var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStarActiveYellow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icStarActiveYellow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Club-profile",
    transform: "translate(-86.000000, -1012.000000)",
    fill: "#FFC107",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(-1.000000, 64.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.000000, 442.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 504.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(51.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pointed-star",
    transform: "translate(25.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0915465,7.60514508 C13.8484832,7.60514508 13.5904689,7.42589017 13.5151718,7.2050179 L11.1360556,0.208641431 C11.0607585,-0.0122826064 10.939254,-0.0122826064 10.8639569,0.208641431 L8.48527397,7.2050179 C8.40997691,7.42594193 8.15196259,7.60514508 7.90889934,7.60514508 L0.210181088,7.60514508 C-0.0328821598,7.60514508 -0.0707473727,7.71581415 0.126054227,7.85257172 L6.35409628,12.1758605 C6.55089788,12.3126181 6.64954245,12.6024903 6.57424538,12.8234143 L4.19561663,19.8193767 C4.12031957,20.0403007 4.21896414,20.1088348 4.41576574,19.972129 L10.6438078,15.6488402 C10.8406094,15.5120826 11.1594572,15.5120826 11.3562588,15.6488402 L17.5843009,19.9725431 C17.7811025,20.1093007 17.8797471,20.0407148 17.80445,19.8197908 L15.4257671,12.8238284 C15.35047,12.6029044 15.4491146,12.3130322 15.6459162,12.1762746 L21.8739582,7.85298582 C22.0707598,7.71622825 22.0328946,7.60555918 21.7898314,7.60555918 L14.0915465,7.60555918 L14.0915465,7.60514508 Z",
    id: "icStarActiveYellow"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarActiveYellow);
export default __webpack_public_path__ + "static/media/icStarActiveYellow.b0ee057c42ccbc4bbc1b8dd3440e133e.svg";
export { ForwardRef as ReactComponent };